import { storeToRefs } from "pinia";
import { useFaqStore } from "store/modules/faqStore";
import { useKnowledgeBaseStore } from "store/modules/knowledgeBaseStore";
import { useRouter } from "vue-router";

/**
 * Shared navigation helper for opening an FAQ category in the main content area.
 * Also used from search results to auto-expand a specific question.
 */
export const useFaqNavigation = () => {
  const router = useRouter();
  const faqStore = useFaqStore();
  const kbStore = useKnowledgeBaseStore();
  const { selectedCategoryUuid, openItemUuid } = storeToRefs(faqStore);
  const { clearSearch } = kbStore;

  const openCategory = async (
    categoryUuid: string,
    itemUuid: string | null = null,
  ): Promise<void> => {
    clearSearch();
    selectedCategoryUuid.value = categoryUuid;
    openItemUuid.value = itemUuid;

    if (router.currentRoute.value.name !== "knowledgeBaseIndex") {
      await router.push({ name: "knowledgeBaseIndex" });
    }

    document
      .getElementById("scrollable-content")
      ?.scrollTo({ top: 0, behavior: "smooth" });
  };

  return { openCategory };
};
